import React, { Component } from 'react';
import {
  Paper,
  IconButton,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import {
  ExpandMore,
} from '@material-ui/icons';

import i18n from '../../i18n';
import AvailabilityEmployeeChip from './AvailabilityEmployeeChip';
import {
  sampleChipEmployee,
  sampleAvailability
} from '../../constants/general';

import '../../assets/stylesheets/ScheduleView.css';

class AvailabilityLegend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: false
    };
  }

  handleExpandClick = () => {
    this.setState(prevState => ({ expandView: !prevState.expandView }));
  };

  render() {
    const { expandView } = this.state;

    return (
      <Paper className="blockContainer">
        <div className="blockHeader">
          <h5>{i18n.t('schedule:legend')}</h5>
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMore color="secondary" />
          </IconButton>
        </div>
        <Collapse in={expandView} timeout="auto">
          <List dense>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[6]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:availableAD')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[5]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:unavailableAD')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[7]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:availableAM')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[8]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:availablePM')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[0]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:bookedAD')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[9]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:bookedDeclined')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[3]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:bookedAMavailablePM')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[4]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:bookedPMavailableAM')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[1]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:bookedAMunavailablePM')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AvailabilityEmployeeChip
                  availability={sampleAvailability[2]}
                  employee={sampleChipEmployee}
                />
              </ListItemIcon>
              <ListItemText primary={i18n.t('availability:bookedPMunavailableAM')} />
            </ListItem>
          </List>
        </Collapse>
      </Paper>
    )
  }
}

export default AvailabilityLegend;
